<div class="container-fluid">
    <form [formGroup]="inputForm">
        <div formGroupName="inputData">
            <app-akit-header 
                title="player" 
                [enableSubHeader]="false"
            >
            </app-akit-header>

            <div class="row pt-3 sub-header">
                <div class="col-3 form-check">
                    <input type="checkbox" class="form-check-input" formControlName="assessment_cb" id="assessment_cb">
                    <span class="cb_option form-check-label" for="assessment_cb">Assessment mode</span>
                </div>
                <div class="col-3">
                </div>    
                <div class="col-6 button-bar d-flex justify-content-end">
                    <button class="btn btn-outline-secondary result-button" (click)="showResult(true)">Result</button>                     
                    <button class="btn btn-outline-secondary solution-button" (click)="showSolutionFc(true)">Solution</button>                     
                    <!-- <input type="checkbox" class="form-check-input" formControlName="solution_cb" id="solution_cb">
                    <span class="cb_option form-check-label" for="solution_cb">Show solution</span> -->
                </div>
            </div>
    
        </div>

    </form>
    
    <div class="row pt-3">
        <div class="col-6 input-section" *ngIf="exerciseId">
            <h2>&nbsp;</h2>
            <div *ngIf="refId && sessionId">
                <app-akit-interaction 
                    [sessionId]="sessionId"
                    [refId]="refId">
                </app-akit-interaction>
            </div>
            <div *ngIf="!refId">
                <app-akit-exercise 
                    [exerciseId]="exerciseId"  [assessmentMode]="assessmentMode"
                    (sessionCreated)="onSessionCreated($event)">
                </app-akit-exercise>
            </div>
        </div>
        <div class="col-6">
            <div *ngIf="(sessionId && showReview); then review_template"></div>
            <ng-template #review_template>
                <h2>Result</h2>
                <app-akit-exercise *ngIf="!refId" [sessionId]="sessionId" reviewMode="true"></app-akit-exercise>
                <app-akit-exercise *ngIf="refId" [sessionId]="sessionId" [refId]="refId" reviewMode="true"></app-akit-exercise>
                <div class="exercise-result" *ngIf="exerciseResult">
                    <table>
                        <tr>
                            <th>Status</th>
                            <td>:</td>
                            <td>{{getExerciseStatus()}}</td>
                        </tr>
                        <tr>
                            <th>Score</th>
                            <td>:</td>
                            <td>{{exerciseResult.scoring.marksEarned}} / {{exerciseResult.scoring.marksTotal}}</td>
                        </tr>
                    </table>
                </div>
            </ng-template>

            <div *ngIf="(sessionId && showSolution); then solution_template"></div>
            <ng-template #solution_template>
                <h2>Solution</h2>
                <app-akit-exercise *ngIf="!refId" [sessionId]="sessionId" solutionMode="true"></app-akit-exercise>
                <app-akit-exercise *ngIf="refId" [sessionId]="sessionId" [refId]="refId" solutionMode="true"></app-akit-exercise>
            </ng-template>
            <ng-template #button_template>
                <button class="form-control solution-button" (click)="showSolution=true">Show solution</button>
            </ng-template>
        </div> 
    </div>
</div>